export const environment = {
  production: false,
  msalConfig: {
    auth: {
      clientId: '0eb154d4-3c0a-4846-9ed9-50bee2e52465',
      authority: 'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
      redirectUri: 'https://euwqtaxtc2wap01.azurewebsites.net',
    },
  },
  graphConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  apiConfig: {
    baseUrl: 'https://euwqtaxtc2wap02.azurewebsites.net/api',
    scopes: ['api://0eb154d4-3c0a-4846-9ed9-50bee2e52465/.default'],
  },
  fileUpload: {
    documentFileMaxSize: 10 * 1024 * 1024,
    requestProcessorFileMaxSize: 5 * 1024 * 1024,
  },
};
